var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10V3L18.364 5.63603C17.2614 4.53345 15.8836 3.72894 14.3599 3.31492C12.2793 2.74957 10.0649 2.94993 8.11951 3.87955C6.17416 4.80917 4.62717 6.40627 3.76001 8.38027C2.89286 10.3543 2.76317 12.574 3.39453 14.6355C4.0259 16.6971 5.37637 18.4635 7.20023 19.6133C9.02409 20.7631 11.2001 21.22 13.3324 20.9008C15.4647 20.5816 17.4116 19.5076 18.8188 17.874C20.007 16.4947 20.7438 14.7939 20.9443 13H18.9282C18.7387 14.3132 18.1785 15.553 17.3035 16.5687C16.209 17.8392 14.6948 18.6746 13.0363 18.9229C11.3779 19.1711 9.68541 18.8158 8.26685 17.9215C6.84829 17.0271 5.79792 15.6533 5.30686 14.0498C4.8158 12.4464 4.91667 10.72 5.59112 9.18465C6.26557 7.64932 7.46879 6.40714 8.98185 5.6841C10.4949 4.96106 12.2172 4.80522 13.8355 5.24494C15.0206 5.56695 16.0922 6.19268 16.9498 7.05024L14 10H21Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.3ad7d1504118b874b374bab0eb648a81.svg";
export { ForwardRef as ReactComponent };